import React from 'react';

import './Check.scss';

function SvgCheck() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#fff"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="check-icon"
    >
      <polyline points="20 6 9 17 4 12" width="5" />
    </svg>
  );
}

export default SvgCheck;
